import { create } from 'zustand';
import { IMainMenu } from '@modules/header/domain/models/menu.model';
interface HeaderVisibilityState {
  mainMenu: IMainMenu[];
  isHeaderHidden: boolean;
  setIsHeaderHidden: (val: boolean) => void;
  shouldForceHideHeader: boolean;
  setShouldForceHideHeader: (val: boolean) => void;
  isGinARaiDeeMenuOpen: boolean;
  setIsGinARaiDeeMenuOpen: (val: boolean) => void;
  isHamburgerOpen: boolean;
  setIsHamburgerOpen: (val: boolean) => void;
  isSearchModalOpen: boolean;
  setIsSearchModalOpen: (val: boolean) => void;
  isMenuMobileOpen: boolean;
  setIsMenuMobileOpen: (val: boolean) => void;
  isSubMenuMobileOpen: boolean;
  setIsSubMenuMobileOpen: (val: boolean) => void;
  isNewsOpen: boolean;
  setIsNewsOpen: (val: boolean) => void;
  isProfilePopupOpen: boolean;
  setIsProfilePopupOpen: (val: boolean) => void;
  isCategoryMenuMobileOpen: boolean;
  setIsCategoryMenuMobileOpen: (val: boolean) => void;
  isPromotionMenuMobileOpen: boolean;
  setIsPromotionMenuMobileOpen: (val: boolean) => void;
}
const defaultMenu = {
  isSearchModalOpen: false,
  isMenuMobileOpen: false,
  isHamburgerOpen: false,
  isGinARaiDeeMenuOpen: false,
  isNewsOpen: false,
  isProfilePopupOpen: false,
  isCategoryMenuMobileOpen: false
};
export const headerStore = create<HeaderVisibilityState>(set => ({
  mainMenu: [{
    id: 'what-i-eat',
    title: 'กินอะไรดี?'
  }, {
    id: 'collection',
    title: 'คอลเลกชัน',
    redirectTo: '/collection'
  }, {
    id: 'product',
    title: 'ผลิตภัณท์ซีพี',
    redirectTo: '/product'
  }, {
    id: 'news',
    title: 'โปรโมชัน'
  }, {
    id: 'tips-tricks',
    title: 'เคล็ดลับ',
    redirectTo: '/tips-tricks'
  }],
  isHeaderHidden: false,
  setIsHeaderHidden: (val: boolean) => {
    set(() => ({
      isHeaderHidden: val
    }));
  },
  shouldForceHideHeader: false,
  setShouldForceHideHeader: (val: boolean) => {
    set(() => ({
      shouldForceHideHeader: val
    }));
  },
  isGinARaiDeeMenuOpen: false,
  setIsGinARaiDeeMenuOpen: (val: boolean) => {
    set(() => ({
      ...defaultMenu,
      isGinARaiDeeMenuOpen: val
    }));
  },
  isHamburgerOpen: false,
  setIsHamburgerOpen: (val: boolean) => {
    set(() => ({
      ...defaultMenu,
      isHamburgerOpen: val
    }));
  },
  isSearchModalOpen: false,
  setIsSearchModalOpen: (val: boolean) => {
    set(() => ({
      ...defaultMenu,
      isSearchModalOpen: val
    }));
  },
  isMenuMobileOpen: false,
  setIsMenuMobileOpen: (val: boolean) => {
    set(() => ({
      ...defaultMenu,
      isMenuMobileOpen: val
    }));
  },
  isSubMenuMobileOpen: false,
  setIsSubMenuMobileOpen: (val: boolean) => {
    set(() => ({
      isSubMenuMobileOpen: val
    }));
  },
  isNewsOpen: false,
  setIsNewsOpen: (val: boolean) => {
    set(() => ({
      ...defaultMenu,
      isNewsOpen: val
    }));
  },
  isProfilePopupOpen: false,
  setIsProfilePopupOpen: (val: boolean) => {
    set(() => ({
      ...defaultMenu,
      isProfilePopupOpen: val
    }));
  },
  isCategoryMenuMobileOpen: false,
  setIsCategoryMenuMobileOpen: (val: boolean) => {
    set(() => ({
      isCategoryMenuMobileOpen: val
    }));
  },
  isPromotionMenuMobileOpen: false,
  setIsPromotionMenuMobileOpen: (val: boolean) => {
    set(() => ({
      isPromotionMenuMobileOpen: val
    }));
  }
}));